const t = {
  name: "knowledge",
  dimensions: { width: 18, height: 18 },
  content: `
    <g clip-path="url(#clip0_6491_47052)">
        <path d="M9 17.25C13.4183 17.25 17 13.6683 17 9.25C17 4.83172 13.4183 1.25 9 1.25C4.58172 1.25 1 4.83172 1 9.25C1 13.6683 4.58172 17.25 9 17.25Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M9 13.25C11.2091 13.25 13 11.4591 13 9.25C13 7.04086 11.2091 5.25 9 5.25C6.79086 5.25 5 7.04086 5 9.25C5 11.4591 6.79086 13.25 9 13.25Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M6.16984 6.42L3.33984 3.59" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M14.6601 14.91L11.8301 12.08" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M11.8301 6.42L14.6601 3.59" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M3.33984 14.91L6.16984 12.08" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
    </g>
  `
};
export {
  t as Knowledge
};
